import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { CountryDto } from '../../../shared/modules/settings/dtos/country.dto';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Contact DTO
 */
export class AgreementContactDto {
  @TransformInt()
  id?: number;
  @TransformDate()
  arrivalAt?: Date | null;
  arrivalAirportName?: string | null;
  arrivalFlightNumber?: string | null;
  @TransformDate()
  departureAt?: Date | null;
  departureAirportName?: string | null;
  departureFlightNumber?: string | null;
  address1?: string | null;
  address2?: string | null;
  phoneLandline?: string | null;
  phoneMobile?: string | null;
  phoneFax?: string | null;
  city?: string | null;
  postCode?: string | null;
  poBox?: string | null;
  county?: string | null;
  state?: string | null;
  @TransformInt()
  countryId?: number | null;
  country?: CountryDto;
}
